import { createBrowserRouter } from "react-router-dom";
import App from "../App";
import Home from '../Pages/users/Home';
import Login from "../Pages/users/Login";
import SignUp from "../Pages/users/SignUp";
import SellerSignup from "../Pages/sellers/Sellercredentials/SellerSignUp";
import SellerLogin from "../Pages/sellers/Sellercredentials/SellerLogin";
import SellerDashboard from "../Pages/sellers/Sellerdashboard/SellerDashBoard";
import MyAccount from "../Pages/users/MyAccount";
import AdminLogin from "../Pages/admin/AdminCredentials/adminLogin";
import ProductDetails from "../Components/ProductDetails";
import CartPage from "../Pages/users/cartPage";
import Confirmation from "../Payments/confirmation";
import Cancel from "../Payments/cancel";
import AdminDashboardLayout from "../Pages/admin/AdminDashBoard/AdminDashboardLayout";
import AdminProfile from "../Pages/admin/AdminCredentials/adminprofile";
import PendingSellers from "../Pages/admin/AdminDashBoard/PendingSellers"; 
import ApprovedSellers from "../Pages/admin/AdminDashBoard/ApprovedSellers";
import RejectedSellers from "../Pages/admin/AdminDashBoard/RejectedSellers";
import Logout from "../Pages/admin/AdminCredentials/Logout";
import OrderDetails from "../Pages/users/OrderDetails";
import ManageCategories from "../Pages/admin/AdminCredentials/ManageCategories";
import ForgotPassword from "../Components/ForgotPassword";
import AllSellers from "../Pages/admin/AdminDashBoard/getAllSellerDetails";
import AdminUsers from "../Pages/admin/AdminDashBoard/ManageCustomers";
import UserDetails from "../Pages/admin/AdminDashBoard/UserDetails";
import SellerView from "../Pages/admin/AdminDashBoard/SellerView";
import AdminQueriesPage from "../Pages/admin/AdminCredentials/AdminQueriesPage";
import CategoryProducts from "../Pages/users/CategoryProduct";


const router = createBrowserRouter([
    {
        path:"/",
        element:<App/>,
        children:[
            {
                path:"/",
                element:<Home/>
            },
            {
               path:"category/:id",
               element:<CategoryProducts/>
            },
            {
                path:"login",
                element:<Login/>
            },{
                path:"Signup",
                element:<SignUp/>
            },
            {
                path:"seller-signup",
                element:<SellerSignup/>
            },
            {
                path:"seller-signin",
                element:<SellerLogin/>
            },
            {
                path:"seller/dashboard",
                element:<SellerDashboard/>
            },
            {
                path:"platformadmin-login",
                element:<AdminLogin/>
            },
            {
            path:"my-account",
            element:<MyAccount/>
            },
            {
                path:"/product/:id",
                element:<ProductDetails/>
            },{
                path:"cart",
                element:<CartPage/>
            },{
                path:"confirmation",
                element:<Confirmation/>
            },{
                path:"cancel",
                element:<Cancel/>
            },
            {
               path:"forgot-password",
               element:<ForgotPassword/>
            },
           {
  path: "orders/:orderId",
  element: <OrderDetails />
},
{
  path: "admin/dashboard",
  element: <AdminDashboardLayout />,
  children: [
    { path: "profile", element: <AdminProfile /> },
    { path: "Manage-Customers", element: <AdminUsers /> },
    { path: "seller-details", element: <AllSellers /> },
    { path: "manage-categories", element: <ManageCategories /> },
    { path: "pending-sellers", element: <PendingSellers /> },
    { path: "approved-sellers", element: <ApprovedSellers /> },
    { path: "rejected-sellers", element: <RejectedSellers /> },
    {path:"user-queries", element:<AdminQueriesPage/>},
    { path: "logout", element: <Logout /> },
    { path: "users/:id", element: <UserDetails /> },
    {path:"seller/:sellerId/*",element:<SellerView/>},
    

  ]
}

        ]
    },

])
export default router